import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
const initialState = {
  assessment_answers: [],
  selectedTab: "this_month",
  assessment_question_type:"",
  selectedGroupType:"",
  selectedAgeResponse:{},
  selectedGuestUUID:"",
  selectedOptionResponse:{},
  selectedLanguage:"",
  selectedLangResponse:{},
  guestScoreDetails:{},
  headingQuestionType:"",
  guestComments:"",
  guestOptions:[],
  assessmentParentTab:"select-assessment",
  assessmentLoading: false,
};

const assessmentReducer = createSlice({
  name: "assessmentReducer",
  initialState,
  reducers: {
    setAssessmentAnswer(state, action) {
      state.assessment_answers = action.payload;
    },
    setAssessmentQuestionType(state, action){
      state.assessment_question_type=action.payload;
    },
    setSelectedTab(state, action) {
      state.selectedTab = action.payload;
    },
    setSelectedAgeGroup(state,action){
      state.selectedGroupType=action.payload;
    },
    resetAssessment(state,action){
      state.assessment_answers= [];
      state.selectedTab= "this_month";
      state.assessment_question_type ="";
      state.selectedGroupType = "";
    },
    setAgeResponse(state,action){
      state.selectedAgeResponse=action.payload;
    },
    setGuestUUID(state,action){
      state.selectedGuestUUID=action.payload;
    },
    setOptionResponse(state,action){
      state.selectedOptionResponse=action.payload;
    },
    setSelectedLang(state,action){
      state.selectedLanguage=action.payload;
    },
    setSelectedLangResponse(state,action){
      state.selectedLangResponse=action.payload;
    },
    resetFunnelingData(state,action){
      state.selectedLanguage="";
      state.selectedGuestUUID="";
      state.selectedAgeResponse={};
      state.selectedOptionResponse={};
      state.assessment_question_type ="";
      state.assessment_answers= [];
      state.selectedGroupType = "";
      state.guestComments = "";
      state.guestOptions = [];
    },
    setGuestScoreDetails(state,action){
      state.guestScoreDetails=action.payload;
    },
    setHeadingQuestionType(state,action){
      state.headingQuestionType=action.payload
    },
    setGuestAreaImprvOptions(state,action){
      state.guestOptions=action.payload
    },
   
    setGuestAreaImprvComments(state,action){
      state.guestComments=action.payload
    },
    setAssessmentParentTab(state,action){
      state.assessmentParentTab=action.payload
    },
    setAssessmentParentLoading(state, action){
      state.assessmentLoading = action.payload;
    }
  },
});
export const { setAssessmentAnswer, setSelectedTab, setAssessmentQuestionType, setGuestAreaImprvComments,setGuestAreaImprvOptions,
  setSelectedAgeGroup, resetAssessment,setAgeResponse,setSelectedLangResponse,setGuestScoreDetails,
  setGuestUUID,setOptionResponse,setSelectedLang,resetFunnelingData,setHeadingQuestionType,setAssessmentParentTab,setAssessmentParentLoading} = assessmentReducer.actions;
export default assessmentReducer.reducer;
